import React, { Component } from 'react'
import classnames from "classnames"
import Button from './shared/Button/index'

import baseStyles from 'custom/base.styl';
import { connect } from "react-redux";
import { profileUpdateStages } from "../store/profile/actions";
import formatAmount from '../utils/formatAmount';
import { profileFetchIfNeeded, profileInvalidate } from './../store/profile/actions';
import Loader from './shared/Loader'

const renderExampleLink = (name, link) => {
  if (!link) {
    return null;
  }
  return (<li><a target="_blank" href={link} rel="noopener noreferrer">{name}</a></li>);
};

class PageTaskCompleted extends Component {
  constructor(props) {
    super(props)

    this._handleOnClickUpdateStages = this._handleOnClickUpdateStages.bind(this)
  }

  componentDidMount() {
    const { load } = this.props;
    load();
  }

  _handleOnClickUpdateStages() {
    this.props.profileUpdateStages()
  }

  render() {
    const { completedDetails, loading } = this.props;
    if (loading || !completedDetails) {
      return <Loader absolute />
    }
    //return (<Button onClick={this._handleOnClickUpdateStages}>Continue</Button>);
    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.content_wide)}>
        <div className={baseStyles.header}>
          <h2 className={baseStyles.title}>Thank you for submitting your paper.</h2>
        </div>
        <p className={classnames(baseStyles.succeess_title, baseStyles.space_bottom)}>You have earned {formatAmount(completedDetails.writer_price)}</p>
        <p className={classnames(baseStyles.content_board__text, baseStyles.space_bottom)}>You will be able to withdraw it if you pass all test stages successfully, so keep <br /> it up! Please see the examples of good and bad essays below and compare <br /> them to your work. This will help you improve your writing!</p>
        <div className={baseStyles.upload_board}>
          <div className={baseStyles.upload_board_body}>
            <ul>
              {renderExampleLink('[Sample Good Essay]', completedDetails.good_essay_sample)}
              {/* {renderExampleLink('[Grading Report for Good Essay]', completedDetails.good_essay_grading_report)} */}
              {renderExampleLink('[Sample Bad Essay]', completedDetails.bad_essay_sample)}
              {/* {renderExampleLink('[Grading Report for Bad Essay]', completedDetails.bad_essay_grading_report)} */}
            </ul>
          </div>
          {/* <a className={classnames(baseStyles.upload_board_footer, baseStyles.button_link)}>Download all</a> */}
          <a className={classnames(baseStyles.upload_board_footer, baseStyles.button_link)} href={completedDetails.good_bad_all || ''} target="_blank" rel="noopener noreferrer">Download all</a>
        </div>
        <Button onClick={this._handleOnClickUpdateStages}>Continue</Button>
      </div>
    );
  }
}

export default connect(
  (state) => {
    const loading = !state.profile || state.profile.isFetching;
    const activeTasks = !loading && state.profile.data && state.profile.data.user && state.profile.data.user.active_tasks;
    const activeTaskEntity = activeTasks && activeTasks.length && activeTasks[0];
    const completedDetails = activeTaskEntity && activeTaskEntity.task && activeTaskEntity.task.data;
    return { completedDetails, loading };
  },
  (dispatch) => ({
    profileUpdateStages: () => (dispatch(profileUpdateStages())),
    load: () => {
      dispatch(profileInvalidate());
      dispatch(profileFetchIfNeeded());
    },
  })
)(PageTaskCompleted);



// WEBPACK FOOTER //
// ./src/components/PageTaskCompleted.js